<template>
  <ul class="db list ma0 pa0 f5 fw3" id="sideBar">
    <li v-for="(item, index) in tree" :key="index" class="flex flex-column" :id="'sideNav_' + item.code">
      <div v-if="expandable(item.code)" @click="toggleExpanding(item.code)" class="nav-item flex flex-row justify-between items-end">
        <div :style="paddingLeft">
          {{ item.title }}
        </div>
        <div>
          <font-awesome-icon v-if="expanded(item.code)" icon="chevron-up"/>
          <font-awesome-icon v-else icon="chevron-down"/>
        </div>
      </div>
      <router-link v-else :item="item" :to="item.route" class="nav-item link" exact-active-class="active">
        <span :style="paddingLeft">
          {{ item.title }}
        </span>
      </router-link>
      <side-nav-menu v-if="expanded(item.code)" :tree="children(item.code)" :level="level + 1"/>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'side-nav-menu',
  props: {
    tree: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    ...mapGetters('settings/menu', ['expanded', 'expandable', 'children']),
    paddingLeft () {
      return 'padding-left: ' + this.level * 25 + 'px;'
    }
  },
  methods: {
    ...mapActions('settings/menu', ['toggleExpanding'])
  }
}
</script>

<style lang="scss" scoped>
.nav-item {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: transparent;
  color: #D9E2EC;
  &:hover {
    background-color: #486581;
  }
  &.active {
    color: #F0F4F8;
    background-color: #486581;
    border-left-color: #9FB3C8;
  }
  cursor: pointer;
}
</style>
